// extracted by mini-css-extract-plugin
export default {"recos":"m2-z","productCardOverride":"n2-z","rowHasBadge":"o2-z"};